import { Observable } from 'rxjs';
import { map, skipWhile } from "rxjs/operators";
import { EndpointsName } from './../../Auth/authTypes';
import { get } from "../../Auth";
import {
    BALParameters,
    BALRareStreamData,
    ProcessLine,
} from "../../types";
import { getBALInitialData, getFirstElementOfArray } from './ALCInitialDataServices';
import { parseBALData, setDataByParams } from '../BALServices/BALHelper';

const buildGetBALInitialDataEndpoint = (param: BALParameters, line: ProcessLine) => `/bal/${line}/${param}/results`;

export const getBALInitialDataTwoLines = (): Observable<any> => {
    return getBALInitialData().pipe(
        map((data: BALRareStreamData[]) => {
            return data.reduce((acc, val) => {
                if (!val.Line || !val.Solution) {
                    return acc;
                }
                acc[val.Line][val.Solution] = setDataByParams(parseBALData(val));
                return acc;
            }, {
                DCCC1: {
                    BU: {},
                    BR: {}
                },
                DCCC2: {
                    BU: {},
                    BR: {}
                }
            })
        }),
    )
}


export const getBALInitialWithLineData = (line: ProcessLine, param: BALParameters) =>
    getFirstElementOfArray(get<BALRareStreamData[]>(EndpointsName.BBF, buildGetBALInitialDataEndpoint(param, line)));
    // INFO: For test
    // of({
    //     "Line": line,
    //     "AirTobaccoTemperatureSP": "65.0",
    //     "Solution": param
    // })

    // export const getBALInitialDataTwoLines = (): Observable<any> => forkJoin({
//     DCCC1_BC: getBALInitialWithLineData(ProcessLine.DCCC1, BALParameters.BC),
//     DCCC1_BS: getBALInitialWithLineData(ProcessLine.DCCC1, BALParameters.BS),
//     DCCC2_BC: getBALInitialWithLineData(ProcessLine.DCCC2, BALParameters.BC),
//     DCCC2_BS: getBALInitialWithLineData(ProcessLine.DCCC2, BALParameters.BS),
// }).pipe(
//     map(el => Object.entries(el).reduce((acc, [key, value]) => {
//         const [line, param] = key.split('_');
//         acc[line][param] = setDataByParams(param, value);
//         return acc;
//     }, {
//         DCCC1: {
//             BC: null,
//             BS: null
//         },
//         DCCC2: {
//             BC: null,
//             BS: null
//         }
//     })),
// );